import React, { useRef, useState } from "react";
import { Select, Spin } from "antd";
import authApi from "../../../api/authApi";
import { type ReferrerEditTarget } from "../../../components/ReferrerEditModal";

type Props = { onPick: (target: ReferrerEditTarget) => void };

type Option = { value: number; label: string; user: any };

/**
 * Tìm BẤT KỲ user nào để gán người giới thiệu — kể cả user chưa có mã mời
 * (những user này không nằm trong bảng bên dưới vì bảng chỉ liệt kê user đã có ref).
 *
 * Có mặt ở đây để CTV chỉ được cấp quyền "referral" vẫn xử lý được ca quên nhập mã
 * mà không cần mở thêm quyền vào trang /user.
 */
function AssignReferrerSearch({ onPick }: Props) {
    const [options, setOptions] = useState<Option[]>([]);
    const [searching, setSearching] = useState(false);
    const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

    const handleSearch = (value: string) => {
        if (timer.current) clearTimeout(timer.current);
        const q = value.trim();
        if (!q) { setOptions([]); return; }
        timer.current = setTimeout(async () => {
            setSearching(true);
            try {
                const { data } = await authApi.lookupReferrer(q);
                const users = (data.data ?? data).users || [];
                setOptions(
                    users.map((u: any) => ({
                        value: u.userId,
                        label: `#${u.userId} · ${u.name || "(chưa đặt tên)"} · ${u.email || "—"}`,
                        user: u,
                    }))
                );
            } catch {
                setOptions([]);
            } finally {
                setSearching(false);
            }
        }, 350);
    };

    return (
        <Select
            showSearch
            value={null}
            className="min-w-[280px]"
            placeholder="Gán mã mời: tìm user theo ID / email / tên"
            filterOption={false}
            onSearch={handleSearch}
            onChange={(_v, option) => {
                const picked = (Array.isArray(option) ? option[0] : option) as Option | undefined;
                if (picked) onPick({ userId: picked.user.userId, name: picked.user.name, email: picked.user.email });
            }}
            options={options}
            notFoundContent={searching ? <Spin size="small" /> : null}
        />
    );
}

export default AssignReferrerSearch;
